import React, { useState } from 'react'
import { Card, Col, Container, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import Breadcrumb from '../../components/Common/Breadcrumb'
import { BackButton } from './BackButton'
import classnames from 'classnames';
import { NotificationsTab } from './NotificationsTab';
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"

export const Notifications = (props) => {

    const citec = localStorage?.getItem("CITEC") ? JSON.parse(localStorage?.getItem("CITEC") ?? `{"labType": '1' }`) : '0'
    const movil = localStorage?.getItem("Movil") ? JSON.parse(localStorage?.getItem("Movil") ?? `{"lId": '1' }`) : '0'

    const [activeTab, setActiveTab] = useState('1');
    const [lab, setLab] = useState(citec);

    const profiletoggle = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
        if (tab === '1'){
            setLab(citec);
        }
        else{
            setLab(movil);
        }
    };

    return (
        <>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 40 }}>
                        <Card className='' style={{ padding: 20 }}>

                            <div className='d-flex justify-content-between'>
                                <Breadcrumb breadcrumbItem1='labCitec' breadcrumbItem2='notifications' />
                                <BackButton props={props} />
                            </div>

                            <Card className='' style={{ padding: 20 }}>

                                <Nav tabs className="nav-tabs-custom nav-justified">
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => { profiletoggle('1'); }}
                                        >
                                            Servicios Laboratorio CITEC
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { profiletoggle('2'); }}
                                        >
                                            Servicios Laboratorio Móvil
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                <TabContent activeTab={activeTab} className="p-4">

                                    <TabPane tabId="1">
                                        <NotificationsTab lab={lab}  /> {/* Colocar un identificador para CITEC */}
                                    </TabPane>

                                    <TabPane tabId="2">
                                        <NotificationsTab lab={lab} /> {/* Colocar un identificador para MÓVIL */}
                                    </TabPane>

                                </TabContent>

                            </Card>
                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />
                </Container>
            </div>
        </>
    )
}
